import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import * as _ from 'lodash';
import { Client } from 'src/app/domain/client';
import { Contract } from 'src/app/domain/contract';
import { ClientService } from 'src/app/services/client.service';
import { ContractService } from 'src/app/services/contract.service';

@Component({
    selector: 'app-edit-text-box',
    templateUrl: './client-selection-box.html',
    styleUrls: ['./client-selection-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClientSelectionBoxDialog implements OnInit {

    searchText: string;
    isForNewContracts: boolean;

    public Client: Client = new Client();
    alreadyAssignedList: Client[] = [];

    public AvailableClientList: Client[] = [];
    AvailableContractList: Contract[] = [];

    SelectedClientList: Client[] = [];
    SelectedContractList: Contract[] = [];

    constructor(
        private clientService: ClientService,

        private contractService: ContractService,
        public dialogRef: MatDialogRef<ClientSelectionBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data) {

        if (data.client) {
            this.isForNewContracts = true;
            this.Client = Object.assign({}, data.client);
        } else {
            this.alreadyAssignedList = data.alreadyAssignedList;
        }
    }

    ngOnInit() {
        if (this.isForNewContracts) {
            this.searchAvailableContracts();
        }
    }

    searchNewClient() {
        this.clientService.getClientList(this.searchText).subscribe(x => {
            this.AvailableClientList = _.differenceBy(x, this.alreadyAssignedList, x => x.Code);
        });
    }

    searchAvailableContracts() {
        this.contractService.getContractsPerClient(this.Client.Code).subscribe(x => {
            this.AvailableContractList = _.differenceBy(x, this.Client.ContractList, x => x.Code);
        });
    }

    setSelectedClients(event: MatSelectionListChange) {
        this.SelectedClientList.push(...event.options.map(x => x.value));
    }

    setSelectedContracts(event: MatSelectionListChange) {
        this.SelectedContractList.push(...event.options.map(x => x.value));
    }

    CanAdd() {
        return this.SelectedClientList.length >= 1 || this.SelectedContractList.length >= 1;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.isForNewContracts) {
            this.dialogRef.close(this.SelectedContractList);
        } else {
            this.dialogRef.close(this.SelectedClientList);
        }
    }

    compareWith = (o1: Contract, o2: Contract) => o1.Code === o2.Code;
}
